/* Silkbath homepage motion: reveal-on-scroll, stat count-up, before/after
   slider drag. No animation library — plain IntersectionObserver + rAF,
   keeps the storefront Lighthouse score intact. Respects prefers-reduced-motion. */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealOnScroll() {
    var els = document.querySelectorAll('[data-sb-reveal]');
    if (!els.length) return;
    if (reduceMotion) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { io.observe(el); });
  }

  function countUp(el) {
    var target = parseFloat(el.dataset.sbCount);
    var suffix = el.dataset.sbCountSuffix || '';
    if (isNaN(target)) return;
    if (reduceMotion) { el.textContent = target + suffix; return; }
    var duration = 1200;
    var start = null;
    function step(ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.round(eased * target) + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function statCountUps() {
    var stats = document.querySelectorAll('[data-sb-count]');
    if (!stats.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          countUp(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    stats.forEach(function (el) { io.observe(el); });
  }

  function compareSliders() {
    document.querySelectorAll('.silkbath-compare-slider').forEach(function (slider) {
      var handle = slider.querySelector('.silkbath-compare-slider__handle');
      var after = slider.querySelector('.silkbath-compare-slider__after');
      if (!handle || !after) return;
      var dragging = false;

      function setPosition(clientX) {
        var rect = slider.getBoundingClientRect();
        setPct(((clientX - rect.left) / rect.width) * 100);
      }
      function setPct(pct) {
        pct = Math.min(100, Math.max(0, pct));
        slider.style.setProperty('--sb-compare', pct + '%');
        handle.setAttribute('aria-valuenow', String(Math.round(pct)));
      }
      handle.addEventListener('keydown', function (e) {
        var cur = parseFloat(handle.getAttribute('aria-valuenow')) || 50;
        var step = e.shiftKey ? 10 : 2;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { setPct(cur - step); e.preventDefault(); }
        else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { setPct(cur + step); e.preventDefault(); }
        else if (e.key === 'Home') { setPct(0); e.preventDefault(); }
        else if (e.key === 'End') { setPct(100); e.preventDefault(); }
      });
      handle.addEventListener('pointerdown', function (e) { dragging = true; handle.setPointerCapture(e.pointerId); });
      window.addEventListener('pointerup', function () { dragging = false; });
      slider.addEventListener('pointermove', function (e) { if (dragging) setPosition(e.clientX); });
      slider.addEventListener('click', function (e) { setPosition(e.clientX); });
    });
  }

  /* Sticky mobile CTA: shows once the hero has scrolled out, hides over the footer. */
  function stickyCta() {
    var bar = document.querySelector('[data-sb-sticky]');
    var hero = document.querySelector('.silkbath-hero') || document.querySelector('.aka-pillar-hero') || document.querySelector('.aka-body__header');
    var footer = document.querySelector('.silkbath-footer');
    if (!bar) return;
    var heroOut = false, footerIn = false;
    function update() { bar.classList.toggle('is-active', heroOut && !footerIn); bar.setAttribute('aria-hidden', String(!(heroOut && !footerIn))); }
    if (hero) {
      new IntersectionObserver(function (e) { heroOut = !e[0].isIntersecting; update(); }, { threshold: 0.05 }).observe(hero);
    } else {
      window.addEventListener('scroll', function () { heroOut = window.scrollY > 500; update(); }, { passive: true });
    }
    if (footer) new IntersectionObserver(function (e) { footerIn = e[0].isIntersecting; update(); }, { threshold: 0.1 }).observe(footer);
  }

  /* GA4 attribution: content page -> cart. Pushes to dataLayer; inert until GA4/GTM is installed. */
  function track(name, params) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, params || {}));
  }
  function analytics() {
    var listName = 'homepage';
    var cards = document.querySelectorAll('.silkbath-product-card');
    if (cards.length) {
      track('view_item_list', { item_list_name: listName, items: Array.prototype.map.call(cards, function (c) {
        var t = c.querySelector('.silkbath-product-card__title'); return { item_name: t ? t.textContent.trim() : '' }; }) });
    }
    cards.forEach(function (card) {
      var title = card.querySelector('.silkbath-product-card__title');
      var name = title ? title.textContent.trim() : '';
      card.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () { track('select_item', { item_list_name: listName, items: [{ item_name: name }] }); });
      });
      var form = card.querySelector('form');
      if (form) form.addEventListener('submit', function () { track('add_to_cart', { item_list_name: listName, items: [{ item_name: name }] }); });
    });
    document.querySelectorAll('[data-sb-track]').forEach(function (el) {
      el.addEventListener('click', function () { track('cta_click', { cta: el.getAttribute('data-sb-track'), item_list_name: listName }); });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    revealOnScroll();
    statCountUps();
    compareSliders();
    stickyCta();
    analytics();
  });
})();
